export default __webpack_public_path__ + "static/media/white-link.41376837.svg";